/**
 * Plan entitlements for white-label / Design features.
 *
 * White-label design (brand logo, colors, custom themes) is ORG-wide — staff
 * accounts inherit it — and only top-tier plans keep it. Display surfaces gate
 * on these helpers so a downgraded org reverts every member to the standard
 * Ogiso design even if stale customization is still stored.
 *
 * Staff profiles carry the org's subscription (backend /me enrichment), so the
 * checks work for every member.
 */
export const TOP_TIER_PLANS = ["agency", "gold", "scale"];

/**
 * Lenient org design entitlement: unknown plan (profile still loading,
 * pre-login) counts as entitled so entitled users don't get a flash of the
 * standard design. Use for APPLYING branding/themes.
 */
export const hasDesignEntitlement = (profile) => {
  const sub = profile?.subscription;
  const name = String(sub?.packageId?.name || "").toLowerCase();
  if (!name) return true;
  return !!sub?.isActive && TOP_TIER_PLANS.includes(name);
};

/**
 * Strict entitlement: only true when the plan is known, active, and top-tier.
 * Use for ENABLING configuration UI (theme picker, white-label panel).
 */
export const hasKnownDesignEntitlement = (profile) => {
  const sub = profile?.subscription;
  const name = String(sub?.packageId?.name || "").toLowerCase();
  return !!name && !!sub?.isActive && TOP_TIER_PLANS.includes(name);
};
